import NextLink from 'next/link';
import NextImage from 'next/image';
import { Image } from 'react-datocms';
import { Badge, Card } from '@zopauk/web-ui';
import { PostCardFragment } from '@/utils/dato/generated';
import { DateMeta, Meta } from '@/components/Modules/Article/Meta';

type PostCardProps = {
  data: PostCardFragment;
  featured?: boolean;
  latest?: boolean;
};

export const PostCard = ({ featured, latest, data }: PostCardProps) => (
  <Card className="flex flex-col">
    <Card.Image className="overflow-hidden">
      {featured || latest ? (
        <Badge className="absolute left-6 top-6 z-[1]" variant="primary">
          {featured ? 'Featured' : latest ? 'Latest' : ''}
        </Badge>
      ) : null}
      {data.featuredImage.responsiveImage ? (
        <Image data={data.featuredImage.responsiveImage} />
      ) : (
        <div style={{ position: 'relative', aspectRatio: '16/9', width: '100%' }}>
          <NextImage
            alt={data.featuredImage.title || 'Featured image'}
            style={{ objectFit: 'contain' }}
            src={data.featuredImage.url}
            unoptimized
            fill
          />
        </div>
      )}
    </Card.Image>
    <Card.Content className="flex flex-col flex-1 justify-items-stretch">
      <h2>{data.title}</h2>
      <p className="mb-auto pb-6">{data.excerpt}</p>
      <Meta article={data} />
      {data?.publishedDate ? <DateMeta date={data.publishedDate} /> : null}
      <Card.Link href={`/blog/article/${data.slug}`} as={NextLink} />
    </Card.Content>
  </Card>
);
